$(document).on('nc.sidePanel.shown nc.sidePanel.reloaded', '#data-side-panel-your-tasks', function () {
    window.yourTasksSidePanel ??= window.sidePanels.getCurrentSidePanel();
    window.yourTasksSidePanel
        .unbind('nc.sidePanel.formSuccess')
        .unbind('nc.sidePanel.formError')
        .on('nc.sidePanel.formSuccess', (e, result, form) => {
            $(form).closest('tr').fadeOut();
        })
        .on('nc.sidePanel.formError', (e, error, form) => {
            const submitBtn = $(form).find('input[type=submit]');
            const value = submitBtn.attr('value');
            const btnClass = submitBtn.attr('class')
            submitBtn.removeClass(['btn-outline-secondary', 'btn-outline-warning'])
                .addClass('btn-danger')
                .attr('value', error.responseJSON?.message ?? 'Unknown error');

            if (error.responseJSON?.explanation) {
                let tr = submitBtn.closest('tr')

                if (!tr.next('tr').find('td').first().hasClass('alert-danger')) {
                    let html = `<tr><td colspan="${tr.find('td').length}" class="alert alert-danger m-0 alert-dismissible align-middle" style="padding: 1rem 0.5rem !important;">`;
                    html += `<i class="fa fa-level-down fa-rotate-180"></i> ${error.responseJSON.explanation}`;
                    html += `<button type="button" class="close h-100" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true" class="font-weight-bold">&times;</span>
                        </button></td></tr>`;
                    tr.after(html);
                }
            }
            setTimeout(() => {
                submitBtn.attr('value', value);
                submitBtn.attr('class', btnClass);
            }, 2000)
        });
});
